<template>
  <div>
    <b-card header="Presupuesto Interno" class="collapsable-card">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showHeader= !showHeader">
        <i :class="showHeader ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="header" class="mt-2" v-model="showHeader">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group
              label="Nro. PI"
              label-for="presupuestoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="presupuestoNumero"
                :value="presupuestoNumero" 
                type= "text"
                readonly>
              </b-form-input>
            </b-form-group>  

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                type= "text"
                readonly>
              </b-form-input>
            </b-form-group>  

            <b-form-group
              label="Accion"
              label-for="accion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="accion"
                :value="accion"
                type= "text"
                readonly>
              </b-form-input>
            </b-form-group>  
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group
              label="Fecha de Registro"
              label-for="fechaRegistro"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="fechaRegistro"
                :value="fechaRegistro | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha de Entrega"
              label-for="fechaEntrega"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="fechaEntrega"
                :value="fechaEntrega | fecha" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Prioridad"
              label-for="prioridad"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="prioridad"
                :value="prioridad" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>  

            <b-form-group
              v-if="showMoneda"
              label="Moneda"
              label-for="moneda"
              :label-cols="labelCols * 2"
              horizontal>
              <b-form-input 
                id="moneda"
                :value="moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>  

            <b-form-group
              v-if="showMoneda"
              label="Cotización USD"
              label-for="monedaCotizacion"
              :label-cols="labelCols * 2"
              description="Cotización de referencia"
              horizontal>
              <b-form-input 
                id="monedaCotizacion"
                :value="monedaCotizacion | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>  
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-card header="Usuarios" class="collapsable-card">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuarios= !showUsuarios">
        <i :class="showUsuarios ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="header" class="mt-2" v-model="showUsuarios">
        <b-list-group>
          <template v-for="{usuario, usuarioRol, key} in usuarios">
            <b-list-group-item
              class="usuarios-list"
              :key="key"> {{ usuario.trim() + ' - ' + usuarioRol.trim() }} </b-list-group-item>
          </template>
        </b-list-group>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'SharedPresupuestoInterno',
  props: {
    labelCols: {
      type: Number,
      default: 1
    },
    // presupuestoInternoId: {
    //   type: Number,
    //   default: 0
    // },
    presupuestoNumero: {
      type: String,
      default: ''
    },
    cliente:  {
      type: String,
      default: ''
    },
    accion:  {
      type: String,
      default: ''
    },    
    prioridad:  {
      type: String,
      default: ''
    },    
    fechaRegistro:  {
      type: String,
      default: ''
    },    
    fechaEntrega:  {
      type: String,
      default: ''
    },    
    usuarios:  {
      type: Array,
      default: []
    },
    showHeaderInit: {
      type: Boolean,
      default: true
    },
    showMoneda: {
      type: Boolean,
      default: false
    },
    moneda:  {
      type: String,
      default: ''
    },    
    monedaCotizacion:  {
      type: Number,
      default: 0
    },    
  },
  data () {
    return {
      showHeader: true,
      showUsuarios: false,
    }
  },
  created() {
    this.showHeader = this.showHeaderInit;
    // console.log(this.usuarios);
  },
  methods: {
  },
}
</script>

<style>
</style>
